import React from "react";

const NoDataAvailable = ({ message, isShowNoDataAvailable, isShowLoader }: any) => {
  return (
    <div className="no-data-available-box">
      {!isShowLoader && isShowNoDataAvailable && (
        <div className="noDataMessage">
          <div className="center-data">
            <img className="text-center" src={"../Images/noData.svg"} height={100} width={100} alt="" />

            <div className="text-secondary " style={{ marginLeft: "-6px", marginTop: "-6px" }}>
              <h3 className="font-16">{message ? message : "No data Available"}</h3>
            </div>
          </div>
        </div>
      )}
      {isShowLoader && (
        <div className="center-data compo-loader">
          <img src={"../Images/loader.gif"} alt="" height={100} width={100} />
        </div>
      )}
    </div>
  );
};

export default NoDataAvailable;
